import React from "react";

const formatAnswer = (answer) => {
  if (typeof answer === 'boolean') return answer ? 'Ja' : 'Nein';
  if (answer === null || answer === undefined || answer === '') return '-';
  return String(answer);
};

const SimpleFormView = ({form}) => {
  return (
    <div>
      <table>
        <tbody>
          {form.map( x => (<tr key={x.id}>
                              <td>{x.query}</td>
                              <td>{formatAnswer(x.answer)}</td>
                           </tr>))}
        </tbody>
      </table>
    </div>
  );
};

export default SimpleFormView;